import { AutodeskActionTypes } from './types';
import { all, takeLatest, call, put } from 'redux-saga/effects';
import Services from '../../services';
import {
  addSameAutodeskFileLoaded,
  getAutodeskAccessTokenSuccess,
  getAutodeskAccessTokenFailure,
  getAutodeskFileSuccess,
  getAutodeskFileFailure
} from './actions';

export function* doGetAutodeskAccessToken(request: any) {
  try {
    const response: {
      access_token: string;
      expires_in: number;
      error?: {
        message: string;
      };
    } = yield call(
      Services.autodesk.getAutodeskAccessToken,
      request.payload.enquiryId
    );

    if (response.access_token) {
      yield put(
        getAutodeskAccessTokenSuccess({
          accessToken: response.access_token,
          expiresIn: response.expires_in
        })
      );
    } else {
      const errMsg = response.error?.message || 'Unable to get access token';
      yield put(getAutodeskAccessTokenFailure(errMsg));
    }
  } catch (error) {
    yield put(getAutodeskAccessTokenFailure('Unable to get access token'));
  }
}

export function* doGetAutodeskFile(request: any) {
  try {
    const response: {
      aspViewerObject: {
        name: string;
        urn: string;
      };
      error?: {
        message: string;
      };
    } = yield call(
      Services.autodesk.getAutodeskFileDetail,
      request.payload.fileId,
      request.payload.enquiryId
    );
    if (response.aspViewerObject) {
      yield put(addSameAutodeskFileLoaded());
      yield put(
        getAutodeskFileSuccess({
          ...response.aspViewerObject,
          id: request.payload.fileId
        })
      );
    } else {
      const errMsg = response.error?.message || 'Unable to get file detail';
      yield put(getAutodeskFileFailure(errMsg));
    }
  } catch (error) {
    yield put(getAutodeskFileFailure('Unable to get file detail'));
  }
}

export function* onGetAutodeskAccessToken() {
  yield takeLatest(
    AutodeskActionTypes.GET_AUTODESK_ACCESS_TOKEN_START,
    doGetAutodeskAccessToken
  );
}

export function* onGetAutodeskFile() {
  yield takeLatest(
    AutodeskActionTypes.GET_AUTODESK_FILE_START,
    doGetAutodeskFile
  );
}

export function* autodeskSagas() {
  yield all([call(onGetAutodeskAccessToken), call(onGetAutodeskFile)]);
}

export default autodeskSagas;
